import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ConcretePumpingHero from './components/ConcretePumpingHero';
import ServiceOverview from './components/ServiceOverview';
import ProjectTypes from './components/ProjectTypes';
import QuoteForm from './components/QuoteForm';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://lgconcretepumping.com';

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  '@id': `${SITE_URL}/services/concrete-pumping#service`,
  name: 'Concrete Pumping Services',
  url: `${SITE_URL}/services/concrete-pumping`,
  description:
    'Professional concrete pumping services for residential and commercial projects in Western NC. Foundations, slabs, walls, driveways, pools, and more.',
  provider: { '@id': `${SITE_URL}/#business` },
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Western North Carolina' },
    { '@type': 'AdministrativeArea', name: 'North Georgia' },
    { '@type': 'AdministrativeArea', name: 'Southwest South Carolina' },
  ],
  serviceType: 'Concrete Pumping',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Concrete Pumping Project Types',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Foundation Pour' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Slab & Flatwork' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Poured Walls' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Pool & Gunite' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Block Fill' } },
    ],
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
    { '@type': 'ListItem', position: 2, name: 'Services', item: `${SITE_URL}/services` },
    { '@type': 'ListItem', position: 3, name: 'Concrete Pumping', item: `${SITE_URL}/services/concrete-pumping` },
  ],
};

const ConcretePumpingPage = () => {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = [];
    [serviceSchema, breadcrumbSchema].forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    document.title = 'Concrete Pumping Services | LG Concrete Pumping Otto NC';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Professional concrete pumping for foundations, slabs, walls, driveways, and pools in Western NC. LG Concrete Pumping & Stone LLC — Otto, NC. Call (828) 634-1304.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}/services/concrete-pumping`);

    return () => { scripts.forEach((s) => s.remove()); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <ConcretePumpingHero />
        <ServiceOverview />
        <ProjectTypes />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
};

export default ConcretePumpingPage;
